/** Group purchased sessions for display, keeping the next unused session to book. */
export function groupPackageSessions(items) {
    const groups = new Map();
    for (const item of items) {
        const key = item.serviceId ?? item.serviceName;
        const group = groups.get(key);
        if (group) {
            group.total += 1;
            if (!item.used) {
                group.remaining += 1;
                if (group.item.used)
                    group.item = item;
            }
        }
        else {
            groups.set(key, { item, total: 1, remaining: item.used ? 0 : 1 });
        }
    }
    return [...groups.values()];
}
//# sourceMappingURL=package-sessions.js.map